import React from "react";
import { Link } from "gatsby";
import StatusBar from "./StatusBar";
import { useTheme } from "../context/ThemeContext";
import { windowTitleFor } from "../utils/windowTitle";
import "../styles/phone-chrome.css";

/**
 * App chrome for every phone route that is not the home screen.
 *
 * The site header and footer are a web page's furniture. Here a route is an
 * app, so it gets a status bar and a nav bar with a back affordance and the
 * screen's title, and nothing else.
 */
const PhoneChrome = ({ location }) => {
  const { theme, toggleTheme } = useTheme();
  const title = windowTitleFor(location);

  return (
    <div className="phone-chrome">
      <StatusBar />
      <div className="nav-bar">
        {/* A link to home, not history.back(). The label says Home, so it
            should go there, and history.length cannot tell a fresh tab from
            one that arrived off-site: popping then lands on about:blank. */}
        <Link to="/" className="nav-back">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M15 4L7 12l8 8"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Home</span>
        </Link>

        <span className="nav-title">{title}</span>

        <button
          type="button"
          className="nav-action"
          onClick={toggleTheme}
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
        >
          {theme === "dark" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle
                cx="12"
                cy="12"
                r="4.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default PhoneChrome;
